import { units } from "../data/courses";
import type { Course, LessonNode, LessonStatus, Skills, Unit } from "../types/learning";

export function currentLesson(course: Course): { unit: Unit; lesson: LessonNode } {
  const unit = units[Math.max(0, Math.min(course.unit - 1, units.length - 1))];
  const lesson = unit.lessons[Math.max(0, Math.min(course.lesson - 1, unit.lessons.length - 1))];
  return { unit, lesson };
}

export function lessonStatus(course: Course, unitNumber: number, lessonIndex: number): LessonStatus {
  if (unitNumber < course.unit) return "done";
  if (unitNumber > course.unit) return "locked";
  if (lessonIndex < course.lesson - 1) return "done";
  if (lessonIndex === course.lesson - 1) return "current";
  return "locked";
}

export function unitProgress(course: Course): number {
  const { unit } = currentLesson(course);
  return Math.round(((course.lesson - 1) / unit.lessons.length) * 100);
}

export const skillLabels: Record<keyof Skills, string> = {
  vocab: "Vocabulary",
  listening: "Listening",
  speaking: "Speaking",
  grammar: "Grammar",
  reading: "Reading",
};

export function weakestSkill(skills: Skills): keyof Skills {
  return (Object.keys(skills) as (keyof Skills)[]).reduce((a, b) => (skills[a] <= skills[b] ? a : b));
}
